/**
 * Format ISO date (Y-m-d) as dd.mm.yyyy.
 * @param {string} isoDate
 * @returns {string}
 */
export function formatRuDate(isoDate) {
    const [year, month, day] = isoDate.split('-');
    return `${day}.${month}.${year}`;
}

/**
 * Period from first to last game.date (Y-m-d).
 * @param {Array<{ date?: string }>} games
 * @returns {string|null}
 */
export function formatGamesPeriod(games) {
    const dates = (games || [])
        .map((game) => game.date)
        .filter(Boolean)
        .sort();

    if (!dates.length) {
        return null;
    }

    const first = dates[0];
    const last = dates[dates.length - 1];

    if (first === last) {
        return formatRuDate(first);
    }

    return `${formatRuDate(first)} – ${formatRuDate(last)}`;
}
